// extracted by mini-css-extract-plugin
export var orderDetails = "_mh-2";
export var orderImage = "_mh-1";
export var orderMeta = "_mh-3";
export var orderSummary = "_mh-0";
export var rightArrow = "_mh-4";